import loginService from '../domain/services/login.service';

const getHomePageBySource = () => {

    if (loginService.isInvoiceOnlyFaciliter())
        return "/invoices"

    if (loginService.isCustomer())
        return "/home"

    if (loginService.isValidRoles(['external-seller']))
        return "/customers"

    if (loginService.isValidRoles(['sales-manager']))
        return "/crm/analytics"

    if (loginService.isValidRoles(['seller']))
        return "/crm/agenda"

    return "/solicitations";
}

export default getHomePageBySource;
